import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthPage from "@/pages/AuthPage";
import MyOrders from "@/pages/MyOrders";
import ResetPassword from "@/pages/ResetPassword";
import { AuthProvider } from "@/lib/auth";
import { AuthDialog } from "@/components/site/AuthDialog";

const HashScroll = () => {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (pathname !== "/" || !hash) return undefined;
    const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView(), 400);
    return () => clearTimeout(t);
  }, [hash, pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <HashScroll />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<AuthPage />} />
            <Route path="/my-orders" element={<MyOrders />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/studio" element={<Navigate to="/#order" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <AuthDialog />
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
